import { render, staticRenderFns } from "./quiz-fix-by-ai.html?vue&type=template&id=6ff0bcb6&scoped=true&external"
import script from "./quiz-fix-by-ai.vue?vue&type=script&lang=js"
export * from "./quiz-fix-by-ai.vue?vue&type=script&lang=js"
import style0 from "./quiz-fix-by-ai.css?vue&type=style&index=0&id=6ff0bcb6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff0bcb6",
  null
  
)

export default component.exports